



















import { Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';

import AnimatedNumber from '../atoms/animated-number.vue';
import { namespace } from 'vuex-class';
import { Modules } from '../../store/store';
import { Mileage } from '../../store/modules/charging-data.interface';
import { ARIA_REFS } from '../../config/accessibility';
import SubHeadline from '../sub-headline/sub-headline.vue';

export type DurationMinutes = number;
const dataModule = namespace(Modules.chargingData);

@Component({
  name: 'eq-web-charging-option',
  components: { AnimatedNumber, SubHeadline },
})
export default class ChargingOption extends Vue {
  @dataModule.Getter('mileage')
  private readonly mileageData!: Mileage | undefined;

  private get ARIA_REFS() {
    return ARIA_REFS;
  }
  private get ariaLabel() {
    if (!this.mileageData) return '';
    if (this.mileageData.min && this.mileageData.max) {
      if (this.mileageData.min === this.mileageData.max) {
        return this.$t('MILEAGE.ARIA_LABEL_SINGLE', {
          value: Math.round(this.mileageData.min),
          unit: this.mileageData?.unit,
        });
      }
      return this.$t('MILEAGE.ARIA_LABEL_RANGE', {
        from: Math.round(this.mileageData.min),
        to: Math.round(this.mileageData.max),
        unit: this.mileageData?.unit,
      });
    } else {
      return '';
    }
  }
}
